import React, { useEffect, useState } from "react";
import { ScrollText, ChevronDown, ChevronUp } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

const STORAGE_KEY = "gf_terms_accepted";

const TERMS = [
  ["Acceptance of Terms", "By clicking 'I Agree', you confirm that you have read, understood, and accepted these terms in full."],
  ["Eligibility", "You represent that you are at least 18 years of age and that the information you provide is accurate and truthful."],
  ["Data Collection & Privacy", "You consent to the collection and processing of your personal information (including name, contact details, and homeowner status) as required for the application process."],
  ["Communication Consent", "By providing your mobile number and email, you agree to be contacted by our Sales Admin, Underwriters, or your selected Packager regarding your application or recruitment inquiry."],
  ["Selection of Packager", "You acknowledge that you are responsible for selecting a Packager from the provided list. The selection of a Packager does not guarantee the approval or funding of any application."],
  ["No Guarantee of Outcome", "Submission of an application through this portal is a request for review only and does not constitute a commitment for funding, approval, or employment."],
  ["Account Security", "If you are provided with login credentials (as a Packager), you are responsible for maintaining their security and must complete a mandatory password change upon your first login."],
  ["Right to Terminate", "We reserve the right to revoke access to the portal or decline any application at our sole discretion."],
];

export const TermsModal = () => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY) !== "true") setOpen(true);
  }, []);

  const agree = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setOpen(false);
  };

  return (
    <Dialog open={open}>
      <DialogContent
        hideCloseButton
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        className="bg-[#F6F5F2] border-[#052F24]/10 rounded-2xl max-w-xl"
        data-testid="terms-modal"
      >
        <DialogHeader>
          <div className="flex items-center gap-2.5 mb-1">
            <ScrollText size={20} className="text-[#052F24]/60" />
            <DialogTitle className="font-display text-2xl font-extrabold tracking-tight">Agree to the Terms and Conditions</DialogTitle>
          </div>
          <DialogDescription className="text-[#052F24]/55 font-light">
            Please accept our terms before using Growth Funds.
          </DialogDescription>
        </DialogHeader>

        <button
          onClick={() => setExpanded((v) => !v)}
          data-testid="terms-show-more-btn"
          className="flex items-center gap-1.5 text-sm font-bold text-[#052F24] hover:opacity-70 transition-opacity -mt-1 outline-none focus-visible:ring-2 focus-visible:ring-[#052F24]/30 rounded-full px-1 -ml-1 justify-self-start"
        >
          {expanded ? <>Show less <ChevronUp size={16} /></> : <>Show more <ChevronDown size={16} /></>}
        </button>

        {expanded && (
          <div className="max-h-[45vh] overflow-y-auto space-y-4 pr-2 -mr-2" data-testid="terms-content">
            {TERMS.map(([title, body], i) => (
              <div key={title}>
                <p className="text-sm font-bold text-[#052F24]">{i + 1}. {title}</p>
                <p className="text-sm font-light text-[#052F24]/70 leading-relaxed mt-1">{body}</p>
              </div>
            ))}
          </div>
        )}

        <button
          onClick={agree}
          data-testid="terms-agree-btn"
          className="w-full bg-[#052F24] text-[#DFFF00] font-bold py-3.5 rounded-full hover:bg-[#0a3d30] transition-colors mt-2"
        >
          I Agree
        </button>
      </DialogContent>
    </Dialog>
  );
};
